import { useState } from 'react'
import { Link } from 'react-router-dom'
import PublicNavBar from './PublicNavBar'
import PublicSideMenu from './PublicSideMenu'

interface PublicLayoutProps {
  children: React.ReactNode
  hideFooter?: boolean
}

export default function PublicLayout({ children, hideFooter }: PublicLayoutProps) {
  const [menuOpen, setMenuOpen] = useState(false)

  return (
    <div className="flex flex-col min-h-screen">
      <PublicNavBar onMenuClick={() => setMenuOpen(true)} />
      <PublicSideMenu isOpen={menuOpen} onClose={() => setMenuOpen(false)} />
      <main className="flex-1">
        {children}
      </main>
      {!hideFooter && (
        <footer className="p-4 pb-8">
          <div className="text-center text-xs text-[var(--text-secondary)] space-y-2 max-w-3xl mx-auto">
            <div className="flex items-center justify-center gap-3">
              <Link to="/about" className="hover:text-[var(--text-primary)] transition-colors">About</Link>
              <span>|</span>
              <Link to="/security" className="hover:text-[var(--text-primary)] transition-colors">Security</Link>
              <span>|</span>
              <Link to="/terms" className="hover:text-[var(--text-primary)] transition-colors">Terms</Link>
              <span>|</span>
              <Link to="/privacy" className="hover:text-[var(--text-primary)] transition-colors">Privacy</Link>
              <span>|</span>
              <a href="https://ko-fi.com/heigh" target="_blank" rel="noopener noreferrer" className="hover:text-[var(--text-primary)] transition-colors">❤️ Buy me a Coffee<span className="sr-only"> (opens in new tab)</span></a>
            </div>
          </div>
        </footer>
      )}
    </div>
  )
}
